import React from "react";
import { css } from "emotion";

export function Unavailable() {
  return <span className={css({ opacity: 0.6 })}>Unavailable</span>;
}
